import { SKILL_JOB_CATEGORY } from './skilljobmap';

export interface GmSkillCatalogEntry {
    skillIdx: number;
    name: string;
}

export const SKILL_CATEGORIES = [
    'Basic',
    'Soldier',
    'Muse',
    'Hawker',
    'Dealer',
    'Special',
    'GM Skills',
    'Other',
];

export function buildSkillCategoryCatalog(category: string): GmSkillCatalogEntry[] {
    const skillData = GDM.getNow('skill_data');
    const table = skillData.data;
    const catalog: GmSkillCatalogEntry[] = [];

    if (!table) {
        return catalog;
    }

    for (let skillIdx = 1; skillIdx < table.rowCount; ++skillIdx) {
        let skillCategory = SKILL_JOB_CATEGORY[skillIdx];
        if (!skillCategory) {
            // The DB-derived map can stop short of ranks present in the current STB.
            const row = skillData.getData(skillIdx);
            const familyId = Number(row[1]);
            const rank = Number(row[2]);
            if (Number.isInteger(familyId) && Number.isInteger(rank)
                && rank > 0 && skillIdx === familyId + rank - 1) {
                skillCategory = SKILL_JOB_CATEGORY[familyId];
            }
        }
        if ((skillCategory || 'Other') !== category) {
            continue;
        }

        let name = '';
        try {
            name = skillData.getName(skillIdx);
        } catch (e) {
            continue;
        }
        if (name) {
            catalog.push({ skillIdx, name });
        }
    }

    return catalog;
}

export function filterSkillCatalog(catalog: GmSkillCatalogEntry[], searchText: string): GmSkillCatalogEntry[] {
    const needle = (searchText || '').trim().toLowerCase();
    if (!needle) {
        return catalog;
    }
    return catalog.filter((entry) => entry.name.toLowerCase().includes(needle));
}
